export interface PrintRevenueSettings {
	title: string
	company_name: string
	company_address: string
	template_html: string
	footer_city_label: string
}

export const DEFAULT_PRINT_REVENUE_SETTINGS: PrintRevenueSettings = {
	title: 'BẢNG DOANH THU NHÂN VIÊN',
	company_name: 'NOI THAT XBOX',
	company_address: '103 Đường số 4, Phường Tam Phú, TP. Thủ Đức, TP.HCM',
	template_html: `<div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; color: #111827;">
	<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px;">
		<div>
			<div style="font-size: 18px; font-weight: 700;">{{company_name_upper}}</div>
			<div>{{company_address}}</div>
		</div>
		<div style="text-align: right;">
			<div style="font-size: 16px; font-weight: 700;">{{title}}</div>
			<div>Ky doanh thu: {{salary_month}}/{{salary_year}}</div>
			<div>Nhan vien: {{employee_name}}</div>
		</div>
	</div>

	<table style="width: 100%; border-collapse: collapse; margin-bottom: 14px;">
		<tr><td style="border: 1px solid #d1d5db; padding: 6px; width: 30%;"><b>Mã nhân viên</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{employee_code}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Doanh thu trong tháng</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{revenue_product_month}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Hoa hồng</b></td><td style="border: 1px solid #d1d5db; padding: 6px; font-weight: 700;">{{commission_amount}}</td></tr>
	</table>

	<div style="margin-bottom: 8px; font-weight: 700;">CHI TIET DON HANG TÍNH THƯỞNG</div>
	{{orders_revenue_table}}

	<div style="margin-top: 18px; text-align: right;">{{footer_city}}, ngày {{current_day}} tháng {{current_month}} năm {{current_year}}</div>
</div>`,
	footer_city_label: 'HCM',
}